import { MarkdownContainer } from '../../../components';

type VideoTranscribeProps = {
  text?: string;
};

export const VideoTranscribe: React.FC<VideoTranscribeProps> = ({ text }) => {
  return (
    <MarkdownContainer className="text-medium mt-md">
      {text ?? ''}
    </MarkdownContainer>
  );
};
